export default __webpack_public_path__ + "static/media/orange-down-arrow.82ed4c6f.svg";